import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const ManagementChartsPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/managementCharts/financial`);
    }
  }, [match]);

  return null;
};

export default ManagementChartsPage;
